import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=3d3e8ab5&scoped=true&"
import script from "./NoContent.vue?vue&type=script&lang=ts&"
export * from "./NoContent.vue?vue&type=script&lang=ts&"
import style0 from "./NoContent.vue?vue&type=style&index=0&id=3d3e8ab5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3e8ab5",
  null
  
)

export default component.exports